import axios from "axios";
import { getBackendUrl } from "./backend-url";

const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "callsheet_token";

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}
export const getToken = () => localStorage.getItem(TOKEN_KEY);

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token if present
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
